import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec6164d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "featureBanner" }
const _hoisted_2 = { class: "featureBanner__wrap" }

import { withDefaults } from 'vue'

import { GetFeatureItem } from '@/models/ApiIF'

import AnimationPushToShadow from '@/components/AnimationPushToShadow/AnimationPushToShadow.vue'
import AppImage from '@/components/AppImage/AppImage.vue'

interface Props {
  feature: GetFeatureItem
  color?: string
  shadowX?: string
  shadowY?: string
  rounded?: string
  imgWidth?: string
  imgHeight?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureBanner',
  props: {
    feature: null,
    color: { default: 'color1' },
    shadowX: { default: '8px' },
    shadowY: { default: '8px' },
    rounded: { default: '16px' },
    imgWidth: { default: '496' },
    imgHeight: { default: '204' }
  },
  setup(__props: any) {

const props = __props as { feature: GetFeatureItem, color: string, shadowX: string, shadowY: string, rounded: string, imgWidth: string, imgHeight: string }

/**
 * FeatureBanner.
 *
 * 特集バナー
 */



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: `/feature/${__props.feature.id}`,
      class: "featureBanner__link animationLink"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(AnimationPushToShadow, {
            backgroundColor: "transparent",
            shadowColor: __props.feature.shadowColorCode,
            shadowX: __props.shadowX,
            shadowY: __props.shadowY,
            rounded: __props.rounded
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: "featureBanner__item",
                style: _normalizeStyle({
              '--feature-banner-border-color': __props.feature.frameColorCode,
              '--feature-banner-rounded': __props.rounded,
            })
              }, [
                _createVNode(AppImage, {
                  src: __props.feature.thumbnailPath,
                  noImageSrc: require('@/assets/image/img_feature_404.svg'),
                  alt: "",
                  width: __props.imgWidth,
                  height: __props.imgHeight
                }, null, 8, ["src", "noImageSrc", "width", "height"])
              ], 4)
            ]),
            _: 1
          }, 8, ["shadowColor", "shadowX", "shadowY", "rounded"])
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})